import React from 'react';
import { FileText, ChartPie, TrendingUpDown, ChartNoAxesColumn, Award } from 'lucide-react';
import './AnalysisTabs.css';

const AnalysisTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="analysis-tabs">
      <button 
        className={`tab-button ${activeTab === 'reports' ? 'active' : ''}`}
        onClick={() => setActiveTab('reports')}
      >
        <FileText size={20} />
        <div className="text-container">
          <span>Reports</span>
        </div>
      </button>
      <button 
        className={`tab-button ${activeTab === 'totals' ? 'active' : ''}`}
        onClick={() => setActiveTab('totals')}
      >
        <ChartPie size={20} />
        <div className="text-container">
          <span>Totals</span>
        </div>
      </button>
      <button 
        className={`tab-button ${activeTab === 'trends' ? 'active' : ''}`}
        onClick={() => setActiveTab('trends')}
      >
        <TrendingUpDown size={20} />
        <div className="text-container">
          <span>Trends</span>
        </div>
      </button>
      <button 
        className={`tab-button ${activeTab === 'rates' ? 'active' : ''}`}
        onClick={() => setActiveTab('rates')}
      >
        <ChartNoAxesColumn size={20} />
        <div className="text-container">
          <span>Rates</span>
        </div>
      </button>
      <button 
        className={`tab-button ${activeTab === 'scores' ? 'active' : ''}`}
        onClick={() => setActiveTab('scores')}
      >
        <Award size={20} />
        <div className="text-container">
          <span>Scores</span>
        </div>
      </button>
    </div>
  );
};

export default AnalysisTabs;